import { Container } from '@pixi/display';
import { Text } from '@pixi/text';
import LocalisedText from './LocalisedText';

export class RankPointsLabel extends Container
{
    private content: Container;
    private pointsNum: Text;
    private pointsLabel: LocalisedText;

    constructor()
    {
        super();

        this.content = new Container();
        this.addChild(this.content);

        this.pointsNum = new Text('', {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            align: 'left',
            fontSize: 50,
            stroke: 0x333333,
            strokeThickness: 10,
            lineJoin: 'round',
        });
        this.pointsNum.anchor.set(0.5, 1);
        this.content.addChild(this.pointsNum);
        this.pointsNum.y = 5;

        this.pointsLabel = new LocalisedText('', {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            align: 'left',
            fontSize: 31,
            stroke: 0x333333,
            strokeThickness: 10,
            lineJoin: 'round',
            maxWidth: 160,
        });
        this.pointsLabel.anchor.set(0.5, 0);
        this.content.addChild(this.pointsLabel);
        this.pointsLabel.y = -12;
    }

    public refresh(points: number | string): void
    {
        this.pointsNum.text = String(points);
        this.pointsLabel.setText(`rankStatsPopup_points`);
    }
}
